import React from "react";

import { CustomInput } from "./CustomInput";
import ColorSelector from "./ColorSelector";
import ImageSelector from "./ImageSelector";
import ThemeSelector from "./ThemeSelector";
import ToolTip from "../../../../parts/tooltip-portal";

export const StorefrontBrandingSection = ({
  active = false,
  handleChange,
  handleSwitch,
  state,
  validateYoutubeLink,
}) => {
  const {
    bannerChanged,
    bannerImg,
    communityLink,
    descriptionSEO,
    facebookLink,
    favicon = {},
    faviconChanged,
    formBannerImg,
    formFavicon = {},
    formPhoneScreenImg,
    formPreviewImg,
    instagramLink,
    introduction,
    introVideo,
    marketingSite,
    phoneScreenChanged,
    phoneScreenImg = {},
    previewImg,
    previewImgChanged,
    storefrontMainColor,
    storefrontSecondaryTextColor,
    storefrontTheme,
    twitterLink,
    youtubeLink,
  } = state;
  return (
    <div
      style={{
        display: active ? "block" : "none",
      }}
      className="storefront-section"
    >
      <article>
        <p className="s1">Storefront Setting</p>
        <section>
          <div className="left-column">
            <label>Storefront Theme</label>
            <ThemeSelector
              value={storefrontTheme}
              inputName="storefrontTheme"
              label="Storefront Theme"
              onChange={handleSwitch}
              isStorefront
              extraMargin
            />
            <ColorSelector
              storefrontMainColor={storefrontMainColor}
              storefrontSecondaryTextColor={storefrontSecondaryTextColor}
              onChange={handleSwitch}
              onChangeColor={handleChange}
            />
          </div>
          <div className="right-column ">
            {
              <img
                src={
                  storefrontTheme === "dark"
                    ? "/img/push-storefront-dark.png"
                    : "/img/push-storefront-light.png"
                }
              />
            }
          </div>
        </section>
      </article>
      <article className="content">
        <p className="s1">Content</p>
        <section>
          <div className="left-side">
            <label>Introduction</label>
            <textarea
              name="introduction"
              className="textarea-input introduction"
              placeholder="Introduction to your clients"
              value={introduction}
              onChange={handleChange}
              sz="large"
            ></textarea>
          </div>
          <div className="right-side">
            <header>
              <label>Description for SEO</label>
              <ToolTip
                body={[
                  "Add a short description of your gym to help with search engine optimization.",
                ]}
              >
                <img
                  className="help-icon"
                  src="/img/new-icons/question-circle.svg"
                />
              </ToolTip>
            </header>
            <textarea
              name="descriptionSEO"
              className="textarea-input"
              placeholder="My Description for SEO"
              value={descriptionSEO}
              onChange={handleChange}
              maxLength={160}
              sz="large"
            />
          </div>
        </section>
      </article>
      <article>
        <p className="s1">Links</p>
        <section>
          <div className="left-side">
            <header>
              <label>Marketing Site Homepage</label>
              <ToolTip
                body={[
                  "The website of your company. This will let your customers go back to your homepage",
                  <br />,
                  "Links must start with http:// or https://",
                ]}
              >
                <img
                  className="help-icon"
                  src="/img/new-icons/question-circle.svg"
                />
              </ToolTip>
            </header>
            <CustomInput
              name="marketingSite"
              onChange={handleChange}
              value={marketingSite}
              placeholder="http://"
            />

            <header>
              <label style={!validateYoutubeLink() ? { color: "#e90b34" } : {}}>
                Intro video (Optional)
              </label>
              <ToolTip body="Create a short video explaining who you are and what your service is. This will be displayed on the About page of your storefront.">
                <img
                  className="help-icon"
                  src="/img/new-icons/question-circle.svg"
                />
              </ToolTip>
              {!validateYoutubeLink() && (
                <ToolTip body="Intro video must be a valid Youtube link">
                  <img
                    width={16}
                    height={16}
                    className="help-icon"
                    src="/img/svg/error-red-exclamation.svg"
                  />
                </ToolTip>
              )}
            </header>
            <CustomInput
              name="introVideo"
              onChange={handleChange}
              value={introVideo}
              placeholder="Link to video"
            />
          </div>

          <div className="right-side">
            <header>
              <label>Community Link (Optional)</label>
              <ToolTip
                body={[
                  "Your link to an existing community on a 3rd party platform (Twitch, discord, etc)",
                  <br />,
                  "Links must start with http:// or https://",
                ]}
              >
                <img
                  className="help-icon"
                  src="/img/new-icons/question-circle.svg"
                />
              </ToolTip>
            </header>
            <CustomInput
              name="communityLink"
              onChange={handleChange}
              value={communityLink}
              placeholder="https://facebook.com/groups/mystrengthbook"
            />
          </div>
        </section>
      </article>
      <article className=" social-wrapper">
        <p className="s1">Social Links</p>
        <section>
          <div className="left-side">
            <label>Instagram</label>
            <CustomInput
              name="instagramLink"
              placeholder="https://mystrengthbook.com"
              value={instagramLink}
              onChange={handleChange}
            />
            <label>Twitter</label>
            <CustomInput
              name="twitterLink"
              placeholder="https://mystrengthbook.com"
              value={twitterLink}
              onChange={handleChange}
            />
          </div>
          <div className="right-side">
            <label>Youtube</label>
            <CustomInput
              name="youtubeLink"
              placeholder="https://mystrengthbook.com"
              value={youtubeLink}
              onChange={handleChange}
            />
            <label>Facebook</label>
            <CustomInput
              name="facebookLink"
              placeholder="https://mystrengthbook.com"
              value={facebookLink}
              onChange={handleChange}
            />
          </div>
        </section>
      </article>
      <article className="wrapper images-wrapper">
        <p className="s1">Graphics</p>
        <section>
          <ImageSelector
            selectorTitle="Upload Banner"
            subInfo={
              <div>
                <span>JPG, GIF, Or PNG.</span>
                <span>2560 x 423 px</span>
              </div>
            }
            title="Banner"
            id="Banner"
            info="2560 x 423 Px"
            //   subInfo="Recommended"
            buttonTitle="Edit Logo"
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="customBranding[bannerImg]"
            imageInputs={[
              { name: "bannerChanged", value: bannerChanged },
              { name: "formBannerImgFile", value: formBannerImg.file || "" },
              { name: "formBannerImgType", value: formBannerImg.type || "" },
              { name: "formBannerImgName", value: formBannerImg.name || "" },
              {
                name: "formBannerImgS3Path",
                value: formBannerImg.s3Path,
              },
            ]}
            value={bannerImg}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={"Required size:\n2560 x 423 Px"}
          />
          <ImageSelector
            title="Phone Screen"
            id="Phone Screen"
            selectorTitle="Upload Image"
            subInfo={
              <div>
                <span>JPG, GIF, Or PNG.</span>
                <span>Max Size: 800kb</span>
              </div>
            }
            buttonTitle="Edit"
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="customBranding[phoneScreenImg]"
            imageInputs={[
              { name: "phoneScreenChanged", value: phoneScreenChanged },
              {
                name: "formPhoneScreenImgFile",
                value: formPhoneScreenImg.file || "",
              },
              {
                name: "formPhoneScreenImgType",
                value: formPhoneScreenImg.type || "",
              },
              {
                name: "formPhoneScreenImgName",
                value: formPhoneScreenImg.name || "",
              },
              {
                name: "formPhoneScreenImgS3Path",
                value: formPhoneScreenImg.s3Path,
              },
            ]}
            value={phoneScreenImg}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={"Max Size: 800kb\n"}
          />
          <ImageSelector
            title="Custom Link Preview"
            id="Preview"
            info="1200 x 628 Px"
            selectorTitle="Upload Image"
            subInfo={
              <div>
                <span>JPG, GIF, Or PNG.</span>
                <span>Max Size: 800kb</span>
              </div>
            }
            buttonTitle="Edit"
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="customBranding[previewImg]"
            imageInputs={[
              { name: "previewImgChanged", value: previewImgChanged },
              {
                name: "formPreviewImgFile",
                value: formPreviewImg.file || "",
              },
              {
                name: "formPreviewImgType",
                value: formPreviewImg.type || "",
              },
              {
                name: "formPreviewImgName",
                value: formPreviewImg.name || "",
              },
              {
                name: "formPreviewImgS3Path",
                value: formPreviewImg.s3Path,
              },
            ]}
            value={previewImg}
            onChange={handleChange}
            allowedExtensions="image/jpeg,image/png"
            showButton={false}
            toolTipTextBody={"Required size:\n1200 x 628 Px"}
          />
          <ImageSelector
            title="Favicon"
            id="Favicon"
            selectorTitle="Upload Image"
            subInfo={
              <div>
                <span>JPG, GIF, Or PNG.</span>
                <span>Max Size: 800kb</span>
              </div>
            }
            inputName="customBranding[favicon]"
            imageInputs={[
              { name: "faviconChanged", value: faviconChanged },
              {
                name: "formFaviconFile",
                value: formFavicon.file || "",
              },
              {
                name: "formFaviconType",
                value: formFavicon.type || "",
              },
              {
                name: "formFaviconName",
                value: formFavicon.name || "",
              },
              {
                name: "formFaviconS3Path",
                value: formFavicon.s3Path,
              },
            ]}
            imageDimensions={{
              marginTop: 0,
            }}
            buttonTitle="Edit"
            value={favicon}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={"Max Size: 800kb\n"}
          />
        </section>
      </article>
    </div>
  );
};
